import type { NameSuggestion } from "../../types";

interface SuggestionChipsProps {
  suggestions: NameSuggestion[];
  isLoading: boolean;
  onSuggestionClick: (suggestion: NameSuggestion) => void;
}

export const SuggestionChips = ({
  suggestions,
  isLoading,
  onSuggestionClick,
}: SuggestionChipsProps) => {
  if (suggestions.length === 0 && !isLoading) {
    return null;
  }

  return (
    <div className="suggestions-chips">
      <div className="suggestions-label">
        Similar names ({suggestions.length}):
      </div>
      <div className="chips-container">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion.id}
            type="button"
            className="suggestion-chip"
            onClick={() => onSuggestionClick(suggestion)}
          >
            {suggestion.name}
          </button>
        ))}
      </div>
      {isLoading && (
        <div className="suggestions-loading">Loading suggestions...</div>
      )}
    </div>
  );
};
